
define('text!areas/home/views/home.html',[],function () { return '<md-module id="home">\r\n</md-module>\r\n';});

